import { render, staticRenderFns } from "./DashboardUpcomingGames.vue?vue&type=template&id=b8fa326a&"
import script from "./DashboardUpcomingGames.vue?vue&type=script&lang=js&"
export * from "./DashboardUpcomingGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports